import React, { useEffect, useState } from 'react';
import axios from 'axios';

const USERS_API = 'https://oppiesfunc.azurewebsites.net/api/getUsers?code=JA76W-z030K296T2l7-RFj85STebU2t-MSjpNIR7iytCAzFubE_a9w==';
const DELETE_API = 'https://oppiesfunc.azurewebsites.net/api/deleteUser?code=d5yODpO10y88-iB3eRxsJTIJ04iqemMljvBPaJQgtTVhAzFuFCCQlA==';

function UserList() {
    const [users, setUsers] = useState([]);
    const [status, setStatus] = useState('');
    const [search, setSearch] = useState('');

    useEffect(() => {
        axios.get(USERS_API)
            .then(res => setUsers(res.data))
            .catch(err => setStatus('Failed to load users.'));
    }, []);

    const handleDelete = async (email) => {
        if (!window.confirm(`Are you sure you want to delete ${email}?`)) return;

        try {
            await axios.post(DELETE_API, { email });
            setUsers(users.filter(user => user.email !== email));
            setStatus(`Deleted ${email}`);
        } catch (err) {
            setStatus('Failed to delete user.');
        }
    };

    const filteredUsers = users.filter((user) => {
        const term = search.toLowerCase();
        return (
            (user.did || '').toLowerCase().includes(term) ||
            (user.email || '').toLowerCase().includes(term) ||
            (user.role || '').toLowerCase().includes(term)
        );
    });

    return (
        <div style={styles.container}>
            <h2 style={styles.heading}>User Management</h2>

            <input
                type="text"
                placeholder="Search by name, email, or role..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={styles.searchInput}
            />

            {status && <p style={styles.status}>{status}</p>}

            {filteredUsers.map((user) => (
                <div key={user.email} style={styles.card}>
                    <p><strong>Name:</strong> {user.did || 'Unknown'}</p>
                    <p><strong>Email:</strong> {user.email}</p>
                    <p><strong>Role:</strong> {user.role}</p>
                    <button style={styles.deleteBtn} onClick={() => handleDelete(user.email)}>Delete</button>
                </div>
            ))}

            {filteredUsers.length === 0 && (
                <p style={{ marginTop: 20, color: '#777' }}>No users found.</p>
            )}
        </div>
    );
}

const styles = {
    container: {
        padding: 30,
        maxWidth: 700,
        margin: '30px auto',
        fontFamily: 'Calibri, sans-serif',
    },
    heading: {
        fontSize: 24,
        color: '#5c4a3b',
        marginBottom: 15,
    },
    searchInput: {
        width: '100%',
        padding: '10px 12px',
        marginBottom: 20,
        borderRadius: 10,
        border: '1px solid #ccc',
        fontSize: 15,
        fontFamily: 'inherit',
    },
    status: {
        background: '#fff7e6',
        padding: '10px 15px',
        borderRadius: 8,
        color: '#664d03',
        marginBottom: 20,
    },
    card: {
        background: '#f9f7f4',
        padding: '10px 15px',
        borderRadius: 12,
        marginBottom: 10,
        boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
        border: '1px solid #e4ddd4',
        fontSize: 14,
        lineHeight: 1.5,
    },
    deleteBtn: {
        marginTop: 8,
        background: '#cc0000',
        color: 'white',
        padding: '6px 12px',
        border: 'none',
        borderRadius: 6,
        cursor: 'pointer',
        fontFamily: 'inherit',
    },
};

export default UserList;
